import * as echarts from "echarts";

const get = (option: any, count: number): Promise<string> => {
  return new Promise((resolve, reject) => {
    // 1. 创建 SVG 临时容器
    const tempDiv = document.createElement("div");
    tempDiv.style.width = "820px";
    tempDiv.style.height = count * 30 + 30 + "px";
    tempDiv.style.position = "fixed";
    tempDiv.style.left = "-9999px";
    document.body.appendChild(tempDiv);

    try {
      // 2. 初始化 SVG renderer
      const chart: any = echarts.init(tempDiv, undefined, {
        renderer: "svg",
      });

      chart.setOption(option);

      // 3. 必须等待渲染完成
      chart.on("finished", () => {
        try {
          // ⬇⬇⬇ 关键：用 zrender painter 导出 SVG（适配 ECharts 5.2.2）
          const zr = chart.getZr();

          let svgContent = "";
          if (zr.painter._svgDom) {
            svgContent = zr.painter._svgDom.outerHTML;
          } else if (zr.painter._svgRoot) {
            svgContent = zr.painter._svgRoot.outerHTML;
          } else {
            throw new Error("SVG DOM not found in ECharts 5.2.2 painter");
          }

          // 4. 清理
          chart.dispose();
          document.body.removeChild(tempDiv);

          resolve(svgContent);
        } catch (err) {
          reject(err);
        }
      });
    } catch (err) {
      reject(err);
    }
  });
};

export default get;